import { forwardRef, memo } from 'react';
import { InputLayout } from './input-layout';
import cn from 'classnames';
import { FieldError } from 'react-hook-form';

type InputDefaults = {
   label?: React.ReactNode;
   type?: 'text' | 'email' | 'password' | 'number' | 'textarea' | 'date' | 'time';
   append?: React.ReactElement | React.ReactNode;
   prepend?: React.ReactElement | React.ReactNode;
   appendClassName?: string;
   prependClassName?: string;
   maxLength?: number;
   max?: number | string;
   readOnly?: boolean;
   placeholder?: string;
};

export type InputProps = {
   labelClassName?: string;
   error?: FieldError | any;
   valid?: React.ReactNode;
   groupClassName?: string;
   name?: string;
   disabled?: boolean;
   autoComplete?: string;
   inputWrapperClassName?: string;
   rows?: number;
   value?: string;
   inputInfo?: string;
   description?: React.ReactNode;
   isRequired?: boolean;
   helperText?: React.ReactNode;
} & InputDefaults &
   React.HTMLAttributes<HTMLInputElement | HTMLTextAreaElement>;

const Input = forwardRef<any, InputProps>(
   (
      {
         type = 'text',
         labelClassName,
         className,
         valid,
         error,
         groupClassName,
         inputWrapperClassName,
         inputInfo,
         description,
         appendClassName,
         id,
         label,
         append,
         prepend,
         isRequired,
         prependClassName,
         helperText,
         ...props
      },
      ref
   ) => {
      const Tag = type === 'textarea' ? 'textarea' : 'input';

      return (
         <InputLayout
            label={label}
            id={id}
            description={description}
            groupClassName={groupClassName}
            error={error}
            valid={valid}
            inputInfo={inputInfo}
            labelClassName={labelClassName}
            isRequired={isRequired}
            helperText={helperText}>
            <div className={cn('flex', inputWrapperClassName)}>
               {prepend && <div className={cn(prependClassName, 'input__prepend')}>{prepend}</div>}
               <Tag
                  id={id}
                  ref={ref}
                  type={type}
                  className={cn(
                     'input',
                     append && 'appended',
                     prepend && 'prepended !border-l-0',
                     className,
                     error && 'input__error',
                     valid && 'input__valid'
                  )}
                  {...props}
               />
               {append && <div className={cn(appendClassName, 'input__append')}>{append}</div>}
            </div>
         </InputLayout>
      );
   }
);
Input.displayName = 'Input';
export default memo(Input);
